import { SET_BRAINTRUST_ENABLED } from './types';
import { fetchBraintrustPlatformConfig } from '../api/partnerQueries';

export const setBraintrustEnabled = (isBraintrustEnabled) => ({
  type: SET_BRAINTRUST_ENABLED,
  payload: { isBraintrustEnabled },
});

export const fetchBraintrustConfig = (simplrAccountId) => async (dispatch) => {
  if (!simplrAccountId) {
    dispatch(setBraintrustEnabled(false));
  }

  try {
    const result = await fetchBraintrustPlatformConfig(simplrAccountId);

    const isBraintrustEnabled = !!(result?.braintrustConfig && result?.braintrustDomain);

    dispatch(setBraintrustEnabled(isBraintrustEnabled));
  } catch (error) {
    dispatch(setBraintrustEnabled(false));
  }
};
